// extracted by mini-css-extract-plugin
module.exports = {"box":"IntentDivider_box_xrJVx"};